<template>
  <div>
    {{error}}
    <br />
    <br />
    <b-row class="text-center">
      <b-col>
        <fb-signin-button
          :params="fbSignInParams"
          @success="onSignInSuccess"
          @error="onSignInError"
        >Sign in with Facebook</fb-signin-button>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row class="text-center">
      <b-col>
        <div class="fb-like" data-share="true" data-width="450" data-show-faces="true"></div>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row class="text-center" v-show="this.name != ''">
      <b-col>
        <qrcode-vue :value="name" :size="size" level="H"></qrcode-vue>
      </b-col>
    </b-row>
    <b-row class="text-center" v-show="this.name != ''">
      <b-col>{{name}}</b-col>
    </b-row>
  </div>
</template>

<script>
window.fbAsyncInit = function() {
  FB.init({
    appId: "509164062995807",
    xfbml: true,
    version: "v4.0"
  });
  FB.AppEvents.logPageView();
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");

import { FBSignInButton } from "vue-facebook-signin-button";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    FBSignInButton,
    QrcodeVue
  },
  data() {
    return {
      name: "",
      error: "",
      size: 300,
      fbSignInParams: {
        scope: "email",
        return_scopes: true
      }
    };
  },
  mounted() {
    if (this.$store.state.server == true) {
      window.location.href = "#/admin";
    }
  },
  methods: {
    onSignInSuccess(response) {
      FB.api("/me", dude => {
        this.name = dude.name;
      });
    },
    onSignInError(error) {
      this.error = error;
    }
  }
};
</script>

<style>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}
</style>